import { LoaderCircle } from "lucide-react";
import TooltipInfo from "./tooltipInfo";

export function CardInfo({ value, label, icon, bgIconColor = "bg-[#ffdebf]", helpText, selected, loading }) {
  const bgcolor = selected ? "bg-[#f9f9f9]" : "bg-white"
  const border = selected ? "border-2" : "border"
  const borderColor = selected ? "border-red-700" : "border-border"
  const cursor = selected ? "hover:cursor-help" : "hover:cursor-pointer"

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center rounded-md py-4 shadow bg-white min-h-[95px]">
          <LoaderCircle className="animate-spin text-red-500 size-8" />
        </div>
      ) : (
        <div className={`flex flex-col rounded-md ${bgcolor} py-4 shadow ${border} ${borderColor}`}>
          <div className="flex gap-4 items-center px-4 justify-between">
            <p className="text-3xl font-bold">{value}</p>
            <div className={`flex items-center justify-center px-2 ${bgIconColor} rounded-md size-8`}>
              {icon}
            </div>
          </div>
          <div className="flex items-center px-4">
            <p className="text-muted-foreground">{label}</p>
            {helpText && <TooltipInfo helpText={helpText} />}
          </div>
        </div>
      )}
    </>

  )
}